import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }     from 'rxjs/Observable';

import { Categoria } from '../model/Categoria';
import { Consorcio } from '../model/Consorcio';

import { UtilitiesService } from '../services/utilities.service'


@Injectable()
export class CategoriaService {

  constructor(
    private _http: Http,
    private _utilities:UtilitiesService

    
  ) { }


  getCategorias(consorcio: Consorcio) : Observable<Categoria[]> {
         
    let json = {   "Metodo": "findCategoria",   "Datos":  consorcio};

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  }

   public insert(categoria: Categoria){
   
    let json = {   "Metodo": "postCategoria",   "Datos": categoria };
    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
  }


public delete(categoria: Categoria){
  
    let json = {   "Metodo": "deleteCategoria",   "Datos": categoria  };
    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/categoria.service.ts